import React from "react";
import "./style.scss";
import SubPic from "assets/images/png/sub-banner.png";
import "./style.scss";
import { CircleTick } from "assets/icons";
import Button from "components/BaseWidgets/button";

const items = [
  "Get priority visibility to reach more potential matches.",
  "Send unlimited messages and connect freely.",
  "View contact details of interested profiles.",
  "Video & voice calls for deeper connections.",
  "Access premium badges to stand out from the crowd.",
  "Ad-free experience for uninterrupted browsing.",
];

function SubscriptionCard({
  title = "Why chose a subscription ?",
  data = items,
  btnText,
}) {
  return (
    <div className="subscription-card">
      <div className="sub-head flex flex-col gap-8">
        <h3 className="font-title-xl">{title}</h3>
        {btnText && (
          <Button href={"/plans"} height={37} className="action-btn">
            {btnText}
          </Button>
        )}
      </div>
      <ul className="list-container">
        {data?.map((each,index) => (
          <li key={index} className="list-items font-title-xs fw-700">
            <CircleTick />
            {each}
          </li>
        ))}
      </ul>
      <div className="sub-banner-pic">
        <img src={SubPic} alt="subscription-banner" />
      </div>
    </div>
  );
}
export default SubscriptionCard;
